export const arraySkill = [
  {
    skill: "Next.js",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/next-icon.png",
  },
  {
    skill: "Typescript",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/typescript-icon.png",
  },
  {
    skill: "Tailwind",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/tailwind-icon.png",
  },
  {
    skill: "Docker",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/docker-icon.png",
  },
  {
    skill: "C#",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/csharp-icon.png",
  },
  {
    skill: "React",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/react-icon.png",
  },
  {
    skill: "Laravel",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/laravel-icon.png",
  },
  {
    skill: "C++",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/cplusplus-icon.png",
  },
  {
    skill: "Java",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/java-icon.png",
  },
  {
    skill: "Python",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/python-icon.webp",
  },
  {
    skill: "Vue.js",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/vue-icon.png",
  },
  {
    skill: "HTML",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/html-icon.png",
  },
  {
    skill: "CSS",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/css-icon.png",
  },
  {
    skill: "Git",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/git-icon.png",
  },
  {
    skill: "Figma",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/figma-icon.png",
  },
  {
    skill: "PHP",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/php-icon.png",
  },
  {
    skill: "Node",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/node-icon.png",
  },
  {
    skill: "MongoDB",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/mongodb-icon.svg",
  },
  {
    skill: "SQLite",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/sqlite-icon.png",
  },
  {
    skill: "Proxmox",
    color: "text-blue-500",
    type: "developer",
    png: "/icons/proxmox-icon.png",
  },
];
